module.exports = __webpack_public_path__ + "img/ASSA.16fb4f3f.jpg";